module.exports = __webpack_public_path__ + "static/media/royaloak-logo.9cccdc24.png";